import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import BRSpan from '../General/BRSpan';
import { loopIndex } from '../../utils/shared';
import DonorName from './DonorName.jsx';

class DonorSeaComponent extends Component {
  constructor(props) {
    super(props);    
    
    this._donorRefs = [];
    this._sortedDonors = [];
    this._screenRegions = [];
    this._currentWave = [];
    this._timeToFadeDonors = _.get(this.props, 'timeToFadeDonors', 5000);    
    this._timeToKeepDonorsOnScreens = 25000;
    this._regionMargin = 0.5
    this._regionWidth = null;
    this._regionHeight = null;
    this._highestDonorFound = 0;
    this._narrowestDonorFound = 1000;
    this._widestDonorFound = 0;
    this._rowsPerRegion = 0;
    this._rowsHeight = 0;
    this._waveDonors = [];
    this._preparedDonors = [];
    this._donorsToFade = [];
    this._donorFadeInIndex = 0;
    this._lastCheckedDonor = 0;
    this._fadeInTimeOutHandler = null;
    this._shuffledDonors = [];
    this._renderedDonors = [];
    this._donorComponentRef = [];
    this._haveDonorsBeenRendered = false;
    this._timeToFadeDonorsIn = _.get(this.props, 'timeToFadeDonorsIn', 3000);
    this._timeToFadeDonorsOut = _.get(this.props, 'timeToFadeDonorsOut', 3000);

    // Margin Percentage
    let regionMarginFromEdges = _.get(this.props, 'regionMarginFromEdges', 2);
    let regionMarginFromTopAndBottom = _.get(this.props, 'regionMarginFromTopAndBottom', 2);
    let minMarginBetweenNamesHorizontally = _.get(this.props, 'minMarginBetweenNamesHorizontally', 5);
    let minMarginBetweenNamesVertically = _.get(this.props, 'minMarginBetweenNamesVertically', 3);
    this._regionMarginFromEdges = regionMarginFromEdges / 100;
    this._regionMarginFromTopAndBottom = regionMarginFromTopAndBottom / 100;
    this._minMarginBetweenNamesHorizontally = minMarginBetweenNamesHorizontally / 100;
    this._minMarginBetweenNamesVertically = minMarginBetweenNamesVertically / 100;
    this._longDonorFactor = 0.025;

    this._allDonorsPushed = [];
    this._donorsLeftBehind = [];
    
    this.setupDonors();
    this.state = {
      finishedPreRender: false,
      showLines: false,
      shuffledDonors: []
    }
  }

  componentDidMount() {
    try {
      document.addEventListener("keydown", this.handleKeyDown);
      setTimeout(() => {
        if (this._donorRefs.length > 0 && this.state.finishedPreRender === false) {
          for (let i = 0; i < this._donorRefs.length; i++) {
            this._sortedDonors[i].height = this._donorRefs[i].offsetHeight;
            this._sortedDonors[i].width = this._donorRefs[i].offsetWidth;
            this._highestDonorFound = this._sortedDonors[i].height > this._highestDonorFound ? this._sortedDonors[i].height : this._highestDonorFound;
            this._widestDonorFound = this._sortedDonors[i].width > this._widestDonorFound ? this._sortedDonors[i].width : this._widestDonorFound;
            this._narrowestDonorFound = this._sortedDonors[i].width < this._narrowestDonorFound ? this._sortedDonors[i].width : this._narrowestDonorFound;
          }
    
          this.setupRegions();
          // console.log("sorted donors", this._sortedDonors);
          // console.log("refs", this._donorRefs);
          // console.log("references", this._donorComponentRef);
          // let regions = this.setupDonorRows();
          // let donors = this.randomizeDonorPositions(regions);
          // let shuffledDonors = _.shuffle(donors);
          // this._shuffledDonors = shuffledDonors;
  
          this.setState({
            finishedPreRender: true,
            shuffledDonors: []
          });
        }
        this.props.setDonorsReady(true);
      }, 2500);
    } catch(e) {
      console.log(e);
    }
  }
  
  componentDidUpdate(prevProps, prevState) {
    // console.log("component updated");
    // console.log("All Donors Pushed", JSON.stringify(this._allDonorsPushed));
    // console.log("All Donors Pushed", this._allDonorsPushed);
    if (this._donorComponentRef.length > 0 && this._haveDonorsBeenRendered === false) {
      this._haveDonorsBeenRendered = true;
    }
  }

  componentWillUnmount = () => {
    clearTimeout(this._fadeInTimeOutHandler);
  }

  handleKeyDown = (event) => {
    switch (event.key) {
      case "l":
        this.setState({
          showLines: !this.state.showLines
        });
        break;
      default:
        break;
    }
  }

  setupDonors = () => {
    try {
      let donors = [];
      let parentActive = {}
      let rootFolder = _.get(this.props.content, 'settings.selected_root_folder', null);
      if (rootFolder !== null) {
        rootFolder = Number(rootFolder);
        parentActive = _.find(this.props.content.story_categories, { id: rootFolder} );
      } else {
        parentActive = _.find(this.props.content.story_categories, (folder) => {
          let type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
          return type === "active";
        });
      }
      let attractLoop = _.find(this.props.content.story_categories, (folder) => {
        let type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
        return folder.parent_category === parentActive.id && type === "attract_loop_donor_lists";
      });
      let donorSeaFolder = _.find(this.props.content.story_categories, (folder) => {
        let type = _.get(folder.contents, 'custom_fields.folder_type.val.value', null);
        return folder.parent_category === attractLoop.id && type === 'donor_lists';
      });
      let donorLists = _.filter(this.props.content.story_categories, { parent_category: donorSeaFolder.id });

      _.forEach(this.props.donors.donorCategories, (donorCategory) => {
        _.forEach(donorLists, (dl) => {
          let folderModules = _.uniqBy(_.filter(this.props.content.folder_modules, { folder: dl.id, model: "donor" }), 'module_id');
          let folderModulesIds = _.map(folderModules, 'module_id');
          let foundDonors = _(donorCategory.donors)
          .filter(donor => folderModulesIds.indexOf(donor.id) > -1)
          .map(dn => {
            let folder = _.find(donorLists, { id: _.get(_.find(folderModules, { module_id: dn.id }), 'folder', null) });
            // let folderType = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
            let fontSize = _.get(folder, 'contents.custom_fields.font_size.val', 1);
            dn.style = { fontSize: fontSize, position:"absolute" }
            return dn;
          }).value();
          donors = donors.concat(foundDonors);
        });
      });

      this._sortedDonors = _.orderBy(donors, [donor => donor.sorting_name.toLowerCase()], ['asc']);
    } catch(e) {
      console.log(e);
    }
  }

  setupRegions = () => {
    const { screensH, screensV, allowedScreens } = this.props;
    const regionWidth = this.props.screen.screenWidth / screensH;
    const regionHeight = this.props.screen.screenHeight / screensV;
    const totalRegions = screensH * screensV;

    this._regionWidth = regionWidth - (regionWidth * this._regionMarginFromEdges * 2);
    this._regionHeight = regionHeight - (regionHeight * this._regionMarginFromTopAndBottom * 2);

    for (let i = 0; i < totalRegions; i++) {
      // Verify for enabled and disabled display regions.
      if (allowedScreens.enabled && allowedScreens.enabled === true) {
        let horizontalRegion = Math.floor(i / screensV);
        let verticalRegion = i % screensV;
        if (allowedScreens.allowedH.indexOf(horizontalRegion) === -1) {
          continue;
        }
  
        if (allowedScreens.allowedV.indexOf(verticalRegion) === -1) {
          continue;
        }
      }

      let top = ((i % screensV) * regionHeight) + (regionHeight * this._regionMarginFromTopAndBottom);
      let left = (Math.floor(i / screensV) * regionWidth) + (regionWidth * this._regionMarginFromEdges);
      this._screenRegions.push({
        style: {
          position:"absolute",
          left: left,
          top: top,
          width: this._regionWidth,
          height: this._regionHeight
        }
      });
    }

    // console.log(this._screenRegions);
  }

  setupDonorRows = () => {
    try {
      let donors = this._sortedDonors;
      let totalRegions = this._screenRegions.length;
      let rowDonors = [];
      let rows = [];
      let index = this._lastCheckedDonor;
      let regions = [];
      
      let rowHeight = 0;
      let rowWidth = 0;
      let rowWidthCondition = 0;
      let totalRowHeight = 0;
      let tmpRow = [];

      for (let i = 0; i < totalRegions; i++) {
        do {
          // if (donors[index].width > this._regionWidth) {
          //   this._donorsLeftBehind.push(donors[index]);
          //   index = loopIndex(index, 0, donors.length - 1, "forward");
          //   continue;
          // }

          if (rowWidthCondition + donors[index].width > this._regionWidth) {
            totalRowHeight += rowHeight + (this._regionHeight * this._minMarginBetweenNamesVertically);
            // let totalRowHeightMinusLastMargin = totalRowHeight - (this._regionHeight * this._minMarginBetweenNamesVertically);

            // Row Width Correction.
            // rowWidth = rowWidth - (this._regionWidth * this._minMarginBetweenNamesHorizontally);
            if (totalRowHeight < this._regionHeight) {
              let marginFromTop = rows.length === 0 ? 0 : this._regionHeight * this._minMarginBetweenNamesVertically;
              rows.push({
                donors: rowDonors,
                height: rowHeight,
                width: rowWidth,
                marginFromTop: marginFromTop
              });
            }
            
            tmpRow = [{
              donors: rowDonors,
              height: rowHeight,
              width: rowWidth,
              marginFromTop: 0
            }];
            rowDonors = [];
            rowWidth = 0;
            rowWidthCondition = 0;
            rowHeight = totalRowHeight < this._regionHeight ? 0 : rowHeight;
          } else {
            donors[index].actual_index = index;
            rowDonors.push(_.cloneDeep(donors[index]));
            this._allDonorsPushed.push(_.cloneDeep(donors[index]));
            rowHeight =  rowHeight > donors[index].height ? rowHeight : donors[index].height;
            rowWidth += donors[index].width;
            rowWidthCondition += (donors[index].width * (1 + this._longDonorFactor)) + (this._regionWidth * this._minMarginBetweenNamesHorizontally);
            index = loopIndex(index, 0, donors.length - 1, "forward");
          }
        } while (totalRowHeight < this._regionHeight);

        regions[i] = {
          rows: rows,
          style: Object.assign({}, this._screenRegions[i].style)
        }

        totalRowHeight = tmpRow && tmpRow.length > 0 ? tmpRow[0].height : 0;
        rows = tmpRow && tmpRow.length > 0 ? tmpRow : [];

        // If there's a temp row and there are no more regions availables,
        // Set the lastCheckedDonor equal to the current donor index (last index checked)
        // Minus the length of the donors contained in the temp row which will be wasted
        if ((i === totalRegions - 1) && (tmpRow.length > 0)) {
          if (index < tmpRow[0].donors.length) {
            this._lastCheckedDonor = tmpRow[0].donors[0].actual_index;
          } else {
            this._lastCheckedDonor = index - tmpRow[0].donors.length;
          }
        } else {
          this._lastCheckedDonor = index;
        }

        // console.log("last donor index", index);
        // console.log("converted", this._lastCheckedDonor);

        rowWidth = 0;
        rowHeight = 0;
        tmpRow = [];
      }
      // console.log("Last Checked Donor Index", this._lastCheckedDonor);
      // console.log("Donors Left Behind", this._donorsLeftBehind);
      return regions;
    } catch(e) {
      console.log(e);
    }
  }

  setupRegionRows = (rows) => {
    let height = 0;
    let regions = this._screenRegions;
    let rIndex = 0;

    for (let i = 0; i < regions.length; i++) {
      height = 0;
      regions[i]['rows'] = [];
      do {
        height += rows[rIndex].height;
        if ((rIndex + 1) >= rows.length) {
          break;
        }

        regions[i].rows.push(rows[rIndex]);

        if ((height + rows[rIndex + 1].height) > this._regionHeight) {
          break;
        }

        rIndex++;
      } while(height < this._regionHeight);
    }

    return regions;
  }

  randomizeDonorPositions = (regions) => {
    try {
      var donors = [];
      for (let i = 0; i < regions.length; i++) {
        var rowTopAccum = 0;
        for (let j = 0; j < regions[i].rows.length; j++) {
          var donorLeftAccum = 0;
          var occupiedSpace = 0;
  
          let marginFromTop = regions[i].rows[j].marginFromTop;
          // console.log('margin from top', marginFromTop);
          let totalEmptyRowSpace = this._regionWidth - regions[i].rows[j].width;
          let emptyRowSpaceLeft = totalEmptyRowSpace;
          for (let k = 0; k < regions[i].rows[j].donors.length; k++) {
            // Top
            let maxTopPadding = regions[i].rows[j].height - regions[i].rows[j].donors[k].height;
            let minTopPadding = 0;
            let randomTopPadding = 0;
            if (maxTopPadding > 0) {
              randomTopPadding = Math.random() * (maxTopPadding - minTopPadding) + minTopPadding;
            }
            let top = regions[i].style.top + rowTopAccum + randomTopPadding + (marginFromTop * j);
    
            // Left
            let max = emptyRowSpaceLeft / (regions[i].rows[j].donors.length - k);
            let min = this._minMarginBetweenNamesHorizontally * this._regionWidth >= max ? max : this._minMarginBetweenNamesHorizontally * this._regionWidth;
            let randomLeft = Math.random() * (max - min) + min;
            occupiedSpace += randomLeft;
            emptyRowSpaceLeft -= randomLeft;
            let left = regions[i].style.left + donorLeftAccum + occupiedSpace;
            donorLeftAccum += regions[i].rows[j].donors[k].width;
    
            let newStyle = Object.assign({}, regions[i].rows[j].donors[k].style);
            newStyle.top = top;
            newStyle.left = left;
            regions[i].rows[j].donors[k].style = newStyle;
            donors.push(Object.assign({}, regions[i].rows[j].donors[k]));
          }
          rowTopAccum += regions[i].rows[j].height;
        }
      }
  
      // console.log('randomized donors', donors);
      return donors;
    } catch(e) {
      console.log(e);
    }
  }

  renderLines = () => {
    let rows = Array.apply(null, { length: this._rowsPerRegion }).map(Number.call, Number);
    let renderedRows = rows.map(i => {
      let style = {
        top: i * this._rowsHeight,
        border: "blue 5px solid",
        position:"absolute",
        width:"100%",
      }

      return (
        <div key={i} style={{ ...style }}/>
      );
    });

    return renderedRows;
  }

  renderWave = () => {
    return this._waveDonors.map((donor, i) => {
      return(
        <span key={i} style={{ ...donor.style, fontSize: `${donor.style.fontSize}vh` }}><BRSpan str={donor.name}/></span>
      );
    });
  }

  setupFadeInDonors = (keepCurrentWave) => {
    for (let i = 0; i < this._sortedDonors.length; i++) {
      if (this._sortedDonors[i].width > (this._regionWidth)) {
        this._donorsLeftBehind.push(this._sortedDonors[i]);
      }
    }

    console.log(this._donorsLeftBehind);

    let shuffledDonors = []
    if (keepCurrentWave) {
      if (this._shuffledDonors.length > 0) {
        this._donorFadeInIndex = 0;
        shuffledDonors = this._shuffledDonors;
      } else {
        this._donorFadeInIndex = 0;
        let regions = this.setupDonorRows();
        let donors = this.randomizeDonorPositions(regions);
        shuffledDonors = _.shuffle(donors);
        this._shuffledDonors = shuffledDonors;
      }
    } else {
      this._donorFadeInIndex = 0;
      let regions = this.setupDonorRows();
      let donors = this.randomizeDonorPositions(regions);
      shuffledDonors = _.shuffle(donors);
      this._shuffledDonors = shuffledDonors;
      this._haveDonorsBeenRendered = false;
    }

    this.setState({
      shuffledDonors: shuffledDonors
    });

    this.setupFadeInInterval();
  }

  setupFadeInInterval = () => {
    try {
      let shuffledDonors = this._shuffledDonors;
      let groupDonorNumber = Math.ceil(shuffledDonors.length / 20);
  
      clearTimeout(this._fadeInTimeOutHandler);
      let timeout = this._haveDonorsBeenRendered ? this._timeToFadeDonorsIn / this._shuffledDonors.length  : 50;
      // console.log("Fade In Timeout is", timeout);
      this._fadeInTimeOutHandler = setTimeout(() => {
        if (this._haveDonorsBeenRendered) {
          if (shuffledDonors.length - this._donorFadeInIndex < groupDonorNumber) {
            groupDonorNumber = shuffledDonors.length - this._donorFadeInIndex;
          }
          // let donorName = this._donorFadeInIndex;
          try {
            this._donorComponentRef[this._donorFadeInIndex].switchNameStatus(true);
            // console.log("Fade Name In");
          } catch(e) {
            console.log(e);
          }
          // console.log("Fading in", this._donorFadeInIndex);
          this._donorFadeInIndex++;
    
          if (this._donorFadeInIndex <= (this._shuffledDonors.length - 1)) {
            this.setupFadeInInterval();
          } else {
            this._donorFadeInIndex = 0;
            // this.setupFadeOutInterval();
          }
        } else {
          this.setupFadeInInterval();
        }
      }, timeout);

    } catch(e) {
      console.log(e);
    }
  }

  setupFadeOutInterval = () => {
    clearTimeout(this._fadeOutTimeOutHandler);
    this._fadeOutTimeOutHandler = setTimeout(() => {
      this.setupFadeOutDonors();
    }, this._timeToKeepDonorsOnScreens);
  }

  setupFadeOutDonors = () => {
    clearTimeout(this._fadeOutDonorsTimeoutHandler);
    this._fadeOutDonorsTimeoutHandler = setTimeout(() => {
      try {
        if (this._donorComponentRef[this._donorFadeInIndex]) {
          this._donorComponentRef[this._donorFadeInIndex].switchNameStatus(false);
        }
        // console.log("Fade Out");
      } catch(e) {
        console.log(e);
      }

      // console.log("Fading out", this._donorFadeInIndex);
      this._donorFadeInIndex++;

      if (this._donorFadeInIndex < this._shuffledDonors.length) {
        this.setupFadeOutDonors();
      }
    }, this._timeToFadeDonorsOut / this._shuffledDonors.length);
  }
  
  preRenderDonors = () => {
    let renderedDonors = this._sortedDonors.map((donor, i) => {
      let donorStyle = {
        fontSize: `${donor.style.fontSize}vh`,
        fontFamily: 'Roboto',
        color: "#000000",
        opacity: 0,
        position:"absolute"
      }
      return (
        <span key={i} ref={el => this._donorRefs[i] = el} style={{ ...donorStyle }}><BRSpan str={donor.name}/></span>
      )
    });

    return renderedDonors;
  }

  render() {
    try {
      return (
        <div>        
          {/* Pre rendering donors to get dimensions */}
          {/* {this.preRenderDonors()} */}
          {this.state.finishedPreRender ? null : this.preRenderDonors()}
          {this.state.showLines ? 
            this.renderLines()
            :
            null
          }
          
          {
            this.state.shuffledDonors.map((donor, i) => {
              return (
                <DonorName
                  key={i}
                  ref={el => this._donorComponentRef[i] = el}
                  name={donor.name}
                  visible={donor.visible}
                  changed={donor.changed}
                  style={donor.style}
                />
              );
            })
          }
        </div>
      );

    } catch(e) {
      console.log(e);
    }
  }
}

const mapStateToProps = (state) => {  
  return {
    screen: state.screen,
    donors: state.donors,
    content: state.content
  };
};

export default connect(mapStateToProps, null, null, { withRef: true })(DonorSeaComponent);


// WEBPACK FOOTER //
// ./src/Components/Donor/DonorSeaComponent.jsx